
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","viewBox":"0 0 8 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.929 6L6.75 2.179a1.061 1.061 0 00-1.5-1.5L.636 5.293a.999.999 0 000 1.414l4.614 4.614a1.061 1.061 0 001.5-1.5L2.929 6z","fill":"#535353"}})])
          )
        }
      }
    